exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button.btn{display:-webkit-box;display:-ms-flexbox;font-weight:700;background:none;display:flex;font-size:14px}button.btn span{line-height:2em;margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./assets/component/back-button.vue
// module id = 276
// module chunks = 0